import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 'AFG', label: 'Afghanistan' },
    { value: 'ALB', label: 'Albania' },
    { value: 'DZA', label: 'Algeria' },
    { value: 'AND', label: 'Andorra' },
    { value: 'AGO', label: 'Angola' },
    { value: 'ATG', label: 'Antigua and Barbuda' },
    { value: 'ARG', label: 'Argentina' },
    { value: 'ARM', label: 'Armenia' },
    { value: 'AUS', label: 'Australia' },
    { value: 'AUT', label: 'Austria' },
    { value: 'AZE', label: 'Azerbaijan' },
    { value: 'BHS', label: 'Bahamas' },
    { value: 'BHR', label: 'Bahrain' },
    { value: 'BGD', label: 'Bangladesh' },
    { value: 'BRB', label: 'Barbados' },
    { value: 'BLR', label: 'Belarus' },
    { value: 'BEL', label: 'Belgium' },
    { value: 'BLZ', label: 'Belize' },
    { value: 'BEN', label: 'Benin' },
    { value: 'BTN', label: 'Bhutan' },
    { value: 'BOL', label: 'Bolivia, Plurinational State of' },
    { value: 'BIH', label: 'Bosnia and Herzegovina' },
    { value: 'BWA', label: 'Botswana' },
    { value: 'BRA', label: 'Brazil' },
    { value: 'BRN', label: 'Brunei Darussalam' },
    { value: 'BGR', label: 'Bulgaria' },
    { value: 'BFA', label: 'Burkina Faso' },
    { value: 'BDI', label: 'Burundi' },
    { value: 'KHM', label: 'Cambodia' },
    { value: 'CMR', label: 'Cameroon' },
    { value: 'CAN', label: 'Canada' },
    { value: 'CPV', label: 'Cabo Verde' },
    { value: 'CAF', label: 'Central African Republic' },
    { value: 'TCD', label: 'Chad' },
    { value: 'CHL', label: 'Chile' },
    { value: 'CHN', label: 'China' },
    { value: 'COL', label: 'Colombia' },
    { value: 'COM', label: 'Comoros' },
    { value: 'COG', label: 'Congo' },
    { value: 'COD', label: 'Congo, the Democratic Republic of the' },
    { value: 'CRI', label: 'Costa Rica' },
    { value: 'CIV', label: "Côte d'Ivoire" },
    { value: 'HRV', label: 'Croatia' },
    { value: 'CUB', label: 'Cuba' },
    { value: 'CYP', label: 'Cyprus' },
    { value: 'CZE', label: 'Czechia' },
    { value: 'DNK', label: 'Denmark' },
    { value: 'DJI', label: 'Djibouti' },
    { value: 'DMA', label: 'Dominica' },
    { value: 'DOM', label: 'Dominican Republic' },
    { value: 'ECU', label: 'Ecuador' },
    { value: 'EGY', label: 'Egypt' },
    { value: 'SLV', label: 'El Salvador' },
    { value: 'GNQ', label: 'Equatorial Guinea' },
    { value: 'ERI', label: 'Eritrea' },
    { value: 'EST', label: 'Estonia' },
    { value: 'ETH', label: 'Ethiopia' },
    { value: 'FJI', label: 'Fiji' },
    { value: 'FIN', label: 'Finland' },
    { value: 'FRA', label: 'France' },
    { value: 'GAB', label: 'Gabon' },
    { value: 'GMB', label: 'Gambia' },
    { value: 'GEO', label: 'Georgia' },
    { value: 'DEU', label: 'Germany' },
    { value: 'GHA', label: 'Ghana' },
    { value: 'GRC', label: 'Greece' },
    { value: 'GRD', label: 'Grenada' },
    { value: 'GTM', label: 'Guatemala' },
    { value: 'GIN', label: 'Guinea' },
    { value: 'GNB', label: 'Guinea-Bissau' },
    { value: 'GUY', label: 'Guyana' },
    { value: 'HTI', label: 'Haiti' },
    { value: 'VAT', label: 'Holy See (Vatican City State)' },
    { value: 'HND', label: 'Honduras' },
    { value: 'HUN', label: 'Hungary' },
    { value: 'ISL', label: 'Iceland' },
    { value: 'IND', label: 'India' },
    { value: 'IDN', label: 'Indonesia' },
    { value: 'IRN', label: 'Iran, Islamic Republic of' },
    { value: 'IRQ', label: 'Iraq' },
    { value: 'IRL', label: 'Ireland' },
    { value: 'ISR', label: 'Israel' },
    { value: 'ITA', label: 'Italy' },
    { value: 'JAM', label: 'Jamaica' },
    { value: 'JPN', label: 'Japan' },
    { value: 'JOR', label: 'Jordan' },
    { value: 'KAZ', label: 'Kazakhstan' },
    { value: 'KEN', label: 'Kenya' },
    { value: 'KIR', label: 'Kiribati' },
    { value: 'KOR', label: 'Korea, Republic of' },
    { value: 'KWT', label: 'Kuwait' },
    { value: 'KGZ', label: 'Kyrgyzstan' },
    { value: 'LAO', label: "Lao People's Democratic Republic" },
    { value: 'LVA', label: 'Latvia' },
    { value: 'LBN', label: 'Lebanon' },
    { value: 'LSO', label: 'Lesotho' },
    { value: 'LBR', label: 'Liberia' },
    { value: 'LBY', label: 'Libya' },
    { value: 'LIE', label: 'Liechtenstein' },
    { value: 'LTU', label: 'Lithuania' },
    { value: 'LUX', label: 'Luxembourg' },
    { value: 'MKD', label: 'North Macedonia, The Republic of' },
    { value: 'MDG', label: 'Madagascar' },
    { value: 'MWI', label: 'Malawi' },
    { value: 'MYS', label: 'Malaysia' },
    { value: 'MDV', label: 'Maldives' },
    { value: 'MLI', label: 'Mali' },
    { value: 'MLT', label: 'Malta' },
    { value: 'MHL', label: 'Marshall Islands' },
    { value: 'MRT', label: 'Mauritania' },
    { value: 'MUS', label: 'Mauritius' },
    { value: 'MEX', label: 'Mexico' },
    { value: 'FSM', label: 'Micronesia, Federated States of' },
    { value: 'MDA', label: 'Moldova, Republic of' },
    { value: 'MCO', label: 'Monaco' },
    { value: 'MNG', label: 'Mongolia' },
    { value: 'MNE', label: 'Montenegro' },
    { value: 'MAR', label: 'Morocco' },
    { value: 'MOZ', label: 'Mozambique' },
    { value: 'MMR', label: 'Myanmar' },
    { value: 'NAM', label: 'Namibia' },
    { value: 'NRU', label: 'Naoero' },
    { value: 'NPL', label: 'Nepal' },
    { value: 'NLD', label: 'Netherlands' },
    { value: 'NZL', label: 'New Zealand' },
    { value: 'NIC', label: 'Nicaragua' },
    { value: 'NER', label: 'Niger' },
    { value: 'NGA', label: 'Nigeria' },
    { value: 'NOR', label: 'Norway' },
    { value: 'OMN', label: 'Oman' },
    { value: 'PAK', label: 'Pakistan' },
    { value: 'PLW', label: 'Palau' },
    { value: 'PSE', label: 'Palestine, State of' },
    { value: 'PAN', label: 'Panama' },
    { value: 'PNG', label: 'Papua New Guinea' },
    { value: 'PRY', label: 'Paraguay' },
    { value: 'PER', label: 'Peru' },
    { value: 'PHL', label: 'Philippines' },
    { value: 'POL', label: 'Poland' },
    { value: 'PRT', label: 'Portugal' },
    { value: 'QAT', label: 'Qatar' },
    { value: 'ROU', label: 'Romania' },
    { value: 'RUS', label: 'Russian Federation' },
    { value: 'RWA', label: 'Rwanda' },
    { value: 'KNA', label: 'Saint Kitts and Nevis' },
    { value: 'LCA', label: 'Saint Lucia' },
    { value: 'VCT', label: 'Saint Vincent and the Grenadines' },
    { value: 'WSM', label: 'Samoa' },
    { value: 'SMR', label: 'San Marino' },
    { value: 'STP', label: 'Sao Tome and Principe' },
    { value: 'SAU', label: 'Saudi Arabia' },
    { value: 'SEN', label: 'Senegal' },
    { value: 'SRB', label: 'Serbia' },
    { value: 'SYC', label: 'Seychelles' },
    { value: 'SLE', label: 'Sierra Leone' },
    { value: 'SGP', label: 'Singapore' },
    { value: 'SVK', label: 'Slovakia' },
    { value: 'SVN', label: 'Slovenia' },
    { value: 'SLB', label: 'Solomon Islands' },
    { value: 'SOM', label: 'Somalia' },
    { value: 'ZAF', label: 'South Africa' },
    { value: 'SSD', label: 'South Sudan' },
    { value: 'ESP', label: 'Spain' },
    { value: 'LKA', label: 'Sri Lanka' },
    { value: 'SDN', label: 'Sudan' },
    { value: 'SUR', label: 'Suriname' },
    { value: 'SWZ', label: 'Eswatini' },
    { value: 'SWE', label: 'Sweden' },
    { value: 'CHE', label: 'Switzerland' },
    { value: 'SYR', label: 'Syrian Arab Republic' },
    { value: 'TWN', label: 'Taiwan' },
    { value: 'TJK', label: 'Tajikistan' },
    { value: 'TZA', label: 'Tanzania, United Republic of' },
    { value: 'THA', label: 'Thailand' },
    { value: 'TLS', label: 'Timor-Leste' },
    { value: 'TGO', label: 'Togo' },
    { value: 'TON', label: 'Tonga' },
    { value: 'TTO', label: 'Trinidad and Tobago' },
    { value: 'TUN', label: 'Tunisia' },
    { value: 'TUR', label: 'Türkiye' },
    { value: 'TKM', label: 'Turkmenistan' },
    { value: 'TUV', label: 'Tuvalu' },
    { value: 'UGA', label: 'Uganda' },
    { value: 'UKR', label: 'Ukraine' },
    { value: 'ARE', label: 'United Arab Emirates' },
    { value: 'GBR', label: 'United Kingdom' },
    { value: 'USA', label: 'United States' },
    { value: 'URY', label: 'Uruguay' },
    { value: 'UZB', label: 'Uzbekistan' },
    { value: 'VUT', label: 'Vanuatu' },
    { value: 'VEN', label: 'Venezuela, Bolivarian Republic of' },
    { value: 'VNM', label: 'Viet Nam' },
    { value: 'ESH', label: 'Western Sahara' },
    { value: 'YEM', label: 'Yemen' },
    { value: 'ZMB', label: 'Zambia' },
    { value: 'ZWE', label: 'Zimbabwe' },
  ],
});
